<div style="height: 300px; width: 100%; margin: auto">
  <canvas #lineChartRef></canvas>
</div>
